<template>
  <section
    id="contact-options"
    class="bg-gradient-to-t from-white to-primary/10"
    role="region"
    aria-labelledby="contact-heading">
    <AboutHero />
    <AboutStory />
    <TestimonialsSection />

    <h2 id="contact-heading" class="text-3xl sm:text-4xl font-semibold text-center text-primary mb-8">
      {{ $t("contact.heading") }}
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4 sm:px-6 md:px-8">
      <ContactOption
        icon="📧"
        :title="$t('contact.options.ticket.title')"
        :description="$t('contact.options.ticket.description')"
        :active="mode === 'ticket'"
        @select="mode = 'ticket'" />

      <ContactOption
        icon="📅"
        :title="$t('contact.options.consult.title')"
        :description="$t('contact.options.consult.description')"
        :active="mode === 'consult'"
        @select="mode = 'consult'" />
    </div>

    <div v-if="mode" class="mt-8 px-4 sm:px-6 md:px-8">
      <component :is="currentComponent" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useContactOptions } from "@/composables/useContactOptions";
import AboutHero from "@/components/sections/abouts/AboutHero.vue";
import AboutStory from "@/components/sections/abouts/AboutStory.vue";
import TestimonialsSection from "@/components/sections/features/TestimonialsSection.vue";
import ContactOption from "@/components/ContactOption.vue";

const { mode, isChatLive, currentComponent } = useContactOptions();

// Poll chat status every 60s
async function checkChatStatus() {
  try {
    const res = await fetch("/api/chat-status");
    const json = await res.json();
    isChatLive.value = json.online;
  } catch {
    isChatLive.value = false;
  }
}

onMounted(() => {
  checkChatStatus();
  setInterval(checkChatStatus, 60000);
});
</script>
